import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { VpButton, VpInfoMenu } from '@vp-ui';
import { Box } from '@mui/material';

const gradientStyles = {
  '.editing-ai-text': {
    position: 'relative',
    color: 'inherit',
  },
  '.editing-ai-text::before': {
    content: 'attr(data-text)',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: 'linear-gradient(to right, #8A2BE2, #DA70D6)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    opacity: 0,
    transition: 'opacity 0.6s ease',
  },
  '&:hover .editing-ai-text::before': {
    opacity: 1,
  },
  '.editing-ai-text > span': {
    transition: 'opacity 0.6s ease',
  },
  '&:hover .editing-ai-text > span': {
    opacity: 0,
  },
};

export const NavItems = withRouter(({ items, history }) => {
  const currentRoute = window.location.pathname;
  
  const renderButtonContent = (text) => {
    if (text === "Editing") {
      return (
        <Box component="span" className="editing-ai-text" data-text="Editing AI">
          <span>Editing AI</span>
        </Box>
      );
    }
    return text;
  };

  return items?.map((item) =>
    item.subpages ? (
      <VpInfoMenu
        key={item?.url}
        menuItems={item.subpages}
        optionalLabelValue="text"
        onSelect={(item) => {
          history.push(item.url);
        }}
        menuButton={
          <VpButton
            key={item?.url}
            variant="navitem"
            current={
              item?.subpages.find((subpage) => currentRoute.includes(subpage.url))
                ? currentRoute
                : undefined
            }
            sx={item.text === "Editing" ? gradientStyles : {}}
          >
            {renderButtonContent(item.text)}
          </VpButton>
        }
      />
    ) : (
      <VpButton
        key={item?.url}
        to={item?.url}
        variant="navitem"
        current={currentRoute.includes(item?.url) ? currentRoute : undefined}
        sx={item.text === "Editing" ? gradientStyles : {}}
      >
        {renderButtonContent(item.text)}
      </VpButton>
    )
  );
});

NavItems.propTypes = {
  items: PropTypes.array,
};

export default NavItems;



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavItems/NavItems.jsx